import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  ListGroup,
  ListGroupItem,
  Popover,
  PopoverBody,
  PopoverHeader,
} from 'reactstrap';

import { InfoIconSvg } from '../../shared/icon-svg/icon';
import { useLocation, useNavigate } from 'react-router';
import ReactGA from 'react-ga4';

const UpcomingPage = () => {
  const [open, setOpen] = useState('1');
  const [modal, setModal] = useState(false);
  const modalToggle = () => setModal(!modal);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    ReactGA.send({ hitType: 'ResourceView', title: 'Resource', page: location.pathname });
  }, [location]);

  const toggle = id => {
    setOpen(open === id ? null : id);
  };
  const resources = [
    {
      id: '1',
      title: 'General EEOC Overview',
      links: [
        {
          text: 'Homepage',
          url: 'https://www.eeoc.gov/',
          content: ' The main EEOC portal, covering all aspects of employment discrimination, rights, and resources.',
        },
        {
          text: 'About the EEOC',
          url: ' https://www.eeoc.gov/about-eeoc',
          content: 'Overview of the EEOC’s mission, organizational structure, and strategic plans.',
        },
      ],
    },
    {
      id: '2',
      title: 'Filing a Charge of Employment Discrimination',
      links: [
        {
          text: 'How to File a Charge of Employment Discrimination',
          url: ' https://www.eeoc.gov/filing-charge-discrimination',
          content: ' Explains how to begin the process, important deadlines, and what to expect.',
        },
        {
          text: 'Charge Filing and Notice of Rights FAQs',
          url: 'https://www.eeoc.gov/filing-charge-discrimination/charge-filing-and-notice-rights-faqs',
          content: 'Answers frequently asked questions about filing charges and what “Notice of Rights” means.',
        },
        {
          text: 'EEOC Public Portal',
          url: ' https://publicportal.eeoc.gov/',
          content:
            'Allows individuals to submit an inquiry, schedule an intake appointment, check the status of a charge, and upload documents.',
        },
      ],
    },
    {
      id: '3',
      title: 'Specific Types of Discrimination',
      links: [
        {
          text: 'Age Discrimination',
          url: 'https://www.eeoc.gov/age-discrimination',
          content: 'Covers rights under the Age Discrimination in Employment Act (ADEA).',
        },
        {
          text: 'Disability Discrimination',
          url: ' https://www.eeoc.gov/disability-discrimination',
          content: 'Details protections under the Americans with Disabilities Act (ADA).',
        },
        {
          text: 'Race/Color Discrimination',
          url: 'https://www.eeoc.gov/racecolor-discrimination',
          content: 'Explains unlawful discrimination and harassment based on race or color.',
        },
        {
          text: 'Religious Discrimination',
          url: 'https://www.eeoc.gov/religious-discrimination',
          content: 'Outlines rights and protections related to religion.',
        },
        {
          text: 'Sex-Based Discrimination',
          url: 'https://www.eeoc.gov/sex-based-discrimination',
          content: 'Discusses discrimination on the basis of sex (including gender identity and sexual orientation).',
        },
        {
          text: 'Sexual Harassment',
          url: 'https://www.eeoc.gov/sexual-harassment',
          content: ' Defines sexual harassment, examples, and steps to take if you experience it.',
        },
        {
          text: 'Pregnancy Discrimination',
          url: ' https://www.eeoc.gov/pregnancy-discrimination',
          content: ' Focuses on the Pregnancy Discrimination Act (PDA) and related protections.',
        },
        {
          text: 'LGBTQ+ Discrimination',
          url: 'https://www.eeoc.gov/lgbtq-i-equality',
          content: 'Information about protections for LGBTQ+ workers under federal law.',
        },
        {
          text: 'Retaliation',
          url: 'https://www.eeoc.gov/retaliation',
          content: ' Covers what retaliation is and how to recognize and prevent it.',
        },
      ],
    },
    {
      id: '4',
      title: 'EEOC Guides and Publications',
      links: [
        {
          text: 'Laws Enforced by EEOC',
          url: 'https://www.eeoc.gov/statutes/laws-enforced-eeoc',
          content: 'Summaries of major federal EEO laws.',
        },
        {
          text: 'Prohibited Employment Policies/Practices',
          url: ' https://www.eeoc.gov/prohibited-employment-policiespractices',
          content: 'Lists common unlawful practices such as job segregation and harassment.',
        },
        {
          text: 'EEOC Publications',
          url: 'https://www.eeoc.gov/publications',
          content: 'Fact sheets, Q&A documents, and best-practice guides for employees and employers.',
        },
      ],
    },
    {
      id: '5',
      title: 'Mediation and Alternative Dispute Resolution',
      links: [
        {
          text: 'Mediation Program Overview',
          url: 'https://www.eeoc.gov/mediation',
          content: 'Explains how mediation works, benefits of using mediation, and how to request it.',
        },
        {
          text: 'EEOC’s Alternative Dispute Resolution (ADR) Program',
          url: 'https://www.eeoc.gov/federal-sector/adr',
          content: 'Focuses on the federal sector ADR process; can be helpful background for private sector employees, too.',
        },
      ],
    },
    {
      id: '6',
      title: 'Litigation, Enforcement, and Statistics',
      links: [
        {
          text: 'Litigation',
          url: 'https://www.eeoc.gov/litigation',
          content: 'Describes the EEOC’s litigation role, how it decides to file suit, and key case examples.',
        },
        {
          text: 'Statistics',
          url: 'https://www.eeoc.gov/statistics',
          content: 'Enforcement and litigation statistics, including annual charge data and trends.',
        },
        {
          text: 'Decisions and Guidance (Federal Sector)',
          url: 'https://www.eeoc.gov/federal-sector/reports',
          content: 'Includes EEOC federal sector decisions, guidance, and policy documents.',
        },
      ],
    },
    {
      id: '7',
      title: 'Federal Sector EEO (For Federal Employees)',
      links: [
        {
          text: 'Federal Sector EEO Portal (FedSEP)',
          url: 'https://www.eeoc.gov/fedsep',
          content: 'An online portal for federal agencies to manage EEO processes.',
        },
        {
          text: 'Overview of Federal Sector EEO Complaint Process',
          url: 'https://www.eeoc.gov/federal-sector/overview-federal-sector-eeo-complaint-process',
          content: 'Step-by-step guide for federal employees and job applicants.',
        },
      ],
    },
    {
      id: '8',
      title: 'Employer Resources',
      links: [
        {
          text: 'Employer Portal',
          url: 'https://www.eeoc.gov/employers',
          content: 'Provides guidance on compliance, EEO-1 reporting, best practices, and training.',
        },
        {
          text: 'Small Business Resource Center',
          url: 'https://www.eeoc.gov/employers/small-business',
          content: 'Tailored help for small businesses on EEO laws and compliance.',
        },
        {
          text: 'EEO-1 Data Collection',
          url: 'https://www.eeoc.gov/employers/eeo-1-data-collection',
          content: 'Information and deadlines for required EEO-1 reporting.',
        },
      ],
    },
    {
      id: '9',
      title: 'Contact Information and Field Offices',
      links: [
        {
          text: 'Contact the EEOC',
          url: 'https://www.eeoc.gov/contact-eeoc',
          content: 'Includes phone numbers, email addresses, and an online contact form.',
        },
        {
          text: 'Find a Field Office',
          url: 'https://www.eeoc.gov/field-office',
          content: 'Links to offices nationwide, where you can file a charge in person or get more information.',
        },
      ],
    },
  ];

  return (
    <>
      <Popover placement="bottom" isOpen={modal} target="tipsButton" toggle={modalToggle} className="tips-popover">
        <PopoverHeader className="d-flex justify-content-between align-items-center">
          Tips for Using These Resources <Button close onClick={modalToggle} />
        </PopoverHeader>
        <PopoverBody>
          <ol>
            <li>Start with the “Filing a Charge of Employment Discrimination” page.</li>
            <li>Use the EEOC Public Portal to submit or check the status of your charge.</li>
            <li>Review Discrimination Types to identify if your situation is covered.</li>
            <li>Consider the Mediation Program as an alternative or supplement to the investigation process.</li>
            <li>Check the FAQ and Guides for specific scenarios and clarifications.</li>
          </ol>
          <p>
            These URLs and categories should help you direct clients quickly to the most relevant EEOC information for their employment
            discrimination concerns.
          </p>
        </PopoverBody>
      </Popover>
      <div className="main-content flex-grow-1 d-flex flex-column gap-5 justify-content-between px-4 pb-4 help-resources-wrapper">
        <div className="custom-container flex-grow-1">
          <div className="help-resources-header mb-3 d-flex flex-wrap gap-3 justify-content-between align-items-center">
            <h1 className="page-title">My Help Resources</h1>
            <p className="tips-link d-flex gap-1" id="tipsButton" onClick={modalToggle}>
              <InfoIconSvg /> Tips for Using These Resources
            </p>
          </div>
          <Card className="card-wrapper">
            {/* <div className="form-wrapper"> */}
            <Accordion open={open} toggle={toggle}>
              {resources.map(resource => (
                <AccordionItem key={resource.id} className="custom-accordion">
                  <AccordionHeader targetId={resource.id}>
                    <div className="step-circle submitted">{resource.id}</div>
                    <span className="p-3 text-left"> {resource.title} </span>
                  </AccordionHeader>
                  <AccordionBody accordionId={resource.id}>
                    {resource.links.length > 0 ? (
                      <ListGroup flush>
                        {resource.links.map((link, index) => (
                          <ListGroupItem key={index} className="resource-link">
                            <strong> {link.text}</strong>
                            <p>
                              <a href={link.url} target="_blank" rel="noopener noreferrer">
                                {' '}
                                {link.url}
                              </a>
                            </p>
                            <p className="resource-description">{link.content}</p>
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    ) : (
                      <p>No resources available.</p>
                    )}
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
            {/* </div> */}
          </Card>
        </div>

        <div className="footer-sec">
          <p>
            <b className="faq" onClick={() => navigate('/case-faqs')}>
              FAQ
            </b>{' '}
            <b>|</b> <b>Disclaimer:</b> We are not a legal service provider. We connect you to referrals and provide reports and initial
            assessments based on best practices. This does not constitute legal advice. Always consult with legal counsel regarding
            specifics.
          </p>
        </div>
      </div>
    </>
  );
};

export default UpcomingPage;
